import { InputAdornment } from "@mui/material";

import { FrmSelectScalarWithObjectOptionsWithHoverHelp } from "components/formFields/FrmSelectScalarWithObjectOptions";
import { FrmTextFieldWithHoverHelp } from "components/formFields/FrmTextFieldWithHoverHelp";

import { i18n } from "services/i18nService";
import {
  CONNECTOR_APP_ID,
  PRIVATE_APP_ID,
  APP_CREDS_ID,
  getShopifyTypeOptions,
} from "services/sosInventoryService/cart/schema";
import { isPersistedRecord } from "services/utility/misc";

import { ShopifyConnectButton } from "views/Carts/Cart/ShopifyConnectButton";

export function ShopifyConnectionFields(props) {
  const {
    record,
    objectType,
    handleInputFieldChange,
    isInError,
    setRecord,
    setErrors,
  } = props;

  const isPersisted = isPersistedRecord(record.id);
  const isConnector = record?.shopifyAppType === CONNECTOR_APP_ID;
  const isPrivate = record?.shopifyAppType === PRIVATE_APP_ID;
  const isAppCreds = record?.shopifyAppType === APP_CREDS_ID;

  return (
    <>
      <FrmSelectScalarWithObjectOptionsWithHoverHelp
        selectProps={{
          name: "shopifyAppType",
          label: i18n("frmLabel.ShopifyAppType"),
          value: record.shopifyAppType,
          onValueChange: handleInputFieldChange,
          options: getShopifyTypeOptions(isPersisted),
          disableClearable: true,
          fullWidth: true,
          disabled: isPersisted,
        }}
        helpText={i18n("hoverHelp.cart.shopifyAppType")}
      />
      {!isConnector && !isAppCreds && (
        <FrmTextFieldWithHoverHelp
          name="authorizationField1"
          value={record.authorizationField1}
          label={
            isPrivate
              ? i18n("frmLabel.ShopifyApiKey")
              : i18n("frmLabel.AdminApiAccessToken")
          }
          onValueBlur={handleInputFieldChange}
          helpText={i18n("hoverHelp.cart.followInstructions")}
          error={isInError("authorizationField1")}
        />
      )}
      {isPrivate && (
        <FrmTextFieldWithHoverHelp
          name="authorizationField2"
          value={record.authorizationField2}
          label={i18n("frmLabel.ShopifyApiPassword")}
          onValueBlur={handleInputFieldChange}
          helpText={i18n("hoverHelp.cart.followInstructions")}
          error={isInError("authorizationField2")}
        />
      )}
      {isAppCreds && (
        <>
          <FrmTextFieldWithHoverHelp
            name="authorizationField1"
            value={record.authorizationField1}
            label={i18n("frmLabel.ShopifyClientId")}
            onValueBlur={handleInputFieldChange}
            helpText={i18n("hoverHelp.cart.followInstructions")}
            error={isInError("authorizationField1")}
          />
          <FrmTextFieldWithHoverHelp
            name="authorizationField2"
            value={record.authorizationField2}
            label={i18n("frmLabel.ShopifyClientSecret")}
            onValueBlur={handleInputFieldChange}
            helpText={
              isPersisted
                ? i18n("hoverHelp.cart.leaveBlankToKeepSecret")
                : i18n("hoverHelp.cart.followInstructions")
            }
            error={isInError("authorizationField2")}
          />
        </>
      )}
      <FrmTextFieldWithHoverHelp
        name="storeIdentifier"
        value={record.storeIdentifier}
        label={i18n("frmLabel.Shop")}
        onValueChange={handleInputFieldChange}
        onValueBlur={handleInputFieldChange}
        helpText={i18n("hoverHelp.cart.followInstructions")}
        endAdornment={
          <InputAdornment
            position="end"
            disableTypography
            sx={{ lineHeight: "normal", color: "disabled", marginRight: 0 }}
          >
            .myshopify.com
          </InputAdornment>
        }
        error={isInError("storeIdentifier")}
      />
      <ShopifyConnectButton
        record={record}
        objectType={objectType}
        onSave={setRecord}
        setErrors={setErrors}
      />
    </>
  );
}
